export const ROOT_DOMAIN = 'regenera.earth';

export const RESERVED_SUBDOMAINS = [
    'www',
    'admin',
    'staging',
    'api',
    'app',
    'test-admin',
    'dev',
    'prod',
    'beta',
    'demo',
    'support',
    'help',
    'contact',
    'about',
    'blog',
    'careers',
    'docs',
    'status',
    'mail',
    'email',
    'ftp',
    'webmail',
    'ns1',
    'ns2',
    'smtp',
    'pop',
    'partner',
    'partners',
    'gov',
    'edu',
    'guardian',
    'guardians',
    'root',
    'portal',
    'dashboard',
    'auth',
    'login',
    'signin',
    'sign-up',
    'signup',
    'register',
    'account',
    'accounts',
    'user',
    'users',
    'coordinator',
    'customer',
    'public',
    'profile',
    'profiles',
    'assets',
    'cdn',
    'static',
    'media',
    'files',
    'download',
    'uploads',
    'graphql',
    'admin-api',
    'internal',
    'stage',
    'uat',
    'preview',
    'test',
];

export const getHostname = () => {
    if (typeof window === 'undefined') return '';
    return window.location.hostname.toLowerCase();
};

export const isLocalhostHost = hostname => {
    return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const isLocalWildcardHost = hostname => {
    return hostname.endsWith('.lvh.me') || hostname.endsWith('.localhost');
};

export const extractSubdomain = hostname => {
    if (!hostname) return null;

    // Production domain
    if (hostname === ROOT_DOMAIN || hostname === `www.${ROOT_DOMAIN}`) {
        return null;
    }

    if (hostname.endsWith(`.${ROOT_DOMAIN}`)) {
        return hostname.replace(`.${ROOT_DOMAIN}`, '');
    }

    // Local test domains like:
    // explorandes.lvh.me
    // test.localhost
    if (isLocalWildcardHost(hostname)) {
        const parts = hostname.split('.');
        if (parts.length >= 3) {
            return parts[0];
        }
    }

    return null;
};

export const isReservedSubdomain = subdomain => {
    if (!subdomain) return false;
    return RESERVED_SUBDOMAINS.includes(subdomain);
};

export const getDomainRoutingInfo = () => {
    const hostname = getHostname();

    if (!hostname) {
        return {
            hostname: '',
            subdomain: null,
            isRootDomain: true,
            isOrgSubdomain: false,
        };
    }

    if (isLocalhostHost(hostname)) {
        return {
            hostname,
            subdomain: null,
            isRootDomain: true,
            isOrgSubdomain: false,
        };
    }

    const subdomain = extractSubdomain(hostname);

    if (!subdomain) {
        return {
            hostname,
            subdomain: null,
            isRootDomain: true,
            isOrgSubdomain: false,
        };
    }

    if (isReservedSubdomain(subdomain)) {
        return {
            hostname,
            subdomain,
            isRootDomain: false,
            isOrgSubdomain: false,
        };
    }

    return {
        hostname,
        subdomain,
        isRootDomain: false,
        isOrgSubdomain: true,
    };
};
